export default {
  transactionCostIdeal: '*inclusief 0.25 EUR transactiekosten',
  transactionCostCreditCard:
    '*inclusief 0.25 EUR transactiekosten & 1% van het order bedrag',
};
